import { useState, useEffect } from "react";

import { API_BASE_URL } from "../config";
import Loader from "./Loader";
import closeIcon from "../assets/close-icon.svg";

export default function JobPreferences({ handlePreferences, details }) {
  // console.log("preferences", details);
  const [selectValue, setSelectValue] = useState("");
  const [preferencesLoading, setPreferencesLoading] = useState(false);
  const [preferencesValue, setPreferencesValue] = useState([]);

  useEffect(() => {
    const fetchPreferences = async () => {
      setPreferencesLoading(true);

      const response = await fetch(`${API_BASE_URL}/preferences`);

      if (!response.ok) {
        return {
          error: response.message || "Failed to fetch preferences.",
        };
      }

      const data = await response.json();
      setPreferencesValue(data.data);
      setPreferencesLoading(false);
    };

    fetchPreferences();
  }, []);

  return (
    <>
      <div className="preferences-wrapper">
        <div className="form-group">
          <label>Preferences</label>
          {preferencesLoading ? (
            <Loader />
          ) : (
            <>
              <select
                value={selectValue}
                onChange={(e) => {
                  const selectedId = parseInt(e.target.value);
                  const selectedPref = preferencesValue.find(
                    (p) => p.id === selectedId
                  );

                  if (selectedPref) {
                    handlePreferences(selectedPref);
                    setSelectValue("");
                  }
                }}
              >
                <option value="">Select Preferences</option>
                {preferencesValue.map((pref) => (
                  <option key={pref.id} value={pref.id}>
                    {pref.name}
                  </option>
                ))}
              </select>
              <div className="preferences-options-wrapper bubble-wrapper-all">
                {details.preferences.map((pref, index) => (
                  <div
                    className="preference-single bubble-remove-all"
                    key={index}
                  >
                    <button
                      type="button"
                      onClick={() => handlePreferences(pref)}
                    >
                      <img src={closeIcon} alt="close-icon" />
                      <input
                        type="checkbox"
                        name="preferences"
                        checked
                        readOnly
                        value={pref.id}
                      />
                    </button>
                    {pref.name}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
